/* global SideDrawer */

if (!customElements.get('search-drawer')) {
  class SearchDrawer extends SideDrawer {
    constructor() {
      super();

      this.searchInput = this.querySelector('.js-search-input');
      this.init();
    }

    /**
     * Wires up the header search icon(s) to open the drawer.
     */
    init() {
      const triggers = document.querySelectorAll('.js-show-search');

      triggers.forEach((trigger) => {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'dialog');

        trigger.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.open(trigger);
        });

        trigger.addEventListener('keydown', (evt) => {
          if (evt.key !== ' ') return;
          evt.preventDefault();
          this.open(trigger);
        });
      });
    }

    /**
     * Opens the drawer and focuses the search input.
     * @param {Element} [opener] - Element that triggered opening of the drawer.
     */
    open(opener) {
      // Close the cart drawer first, if it happens to be open, so only one drawer shows at a time.
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));

      super.open(opener, this.searchInput);
    }
  }

  customElements.define('search-drawer', SearchDrawer);
}
